import {CSSProperties} from '../../../styleSheet';
import {BaseSizePxProps} from '../types';

export const buildSizeStyle = ({
  width,
  height,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
}: BaseSizePxProps = {}): CSSProperties => {
  return {
    ...(width !== undefined
      ? {width: typeof width === 'string' ? width : `${width}px`}
      : {}),
    ...(height !== undefined
      ? {height: typeof height === 'string' ? height : `${height}px`}
      : {}),
    ...(minWidth !== undefined
      ? {
          ['min-width']:
            typeof minWidth === 'string' ? minWidth : `${minWidth}px`,
        }
      : {}),
    ...(maxWidth !== undefined
      ? {
          ['max-width']:
            typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`,
        }
      : {}),
    ...(minHeight !== undefined
      ? {
          ['min-height']:
            typeof minHeight === 'string' ? minHeight : `${minHeight}px`,
        }
      : {}),
    ...(maxHeight !== undefined
      ? {
          ['max-height']:
            typeof maxHeight === 'string' ? maxHeight : `${maxHeight}px`,
        }
      : {}),
  };
};
